import React from 'react'
import {Box,Grid} from '@mui/material'
import ImageGallery from 'react-image-gallery';
import Gallery from 'react-grid-gallery';
import boat from '../res/customers/boat.webp'
import champ from '../res/customers/champ.webp'
import juice from '../res/customers/juice.webp'
import purple from '../res/customers/purple.webp'
import mori from '../res/customers/mori.webp'
import birthday from '../res/customers/birthday.webp'
import graduation from '../res/customers/graduation.webp'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Image from 'mui-image'
import review from '../res/services/review.webp'


const overlay= (<Box sx={{backgroundColor:'rgba(210,165,90,0.3)',width:'100%',height:'100%', display:'flex'}}></Box>)




const CustomerGallery = () => {

    const theme = useTheme()
    const md_down = useMediaQuery(theme.breakpoints.down('md'));





    const images=[
        {
            src: boat,
            thumbnail: boat,
            originalAlt:'Shirt and tumbler design',
            
            thumbnailHeight: 150,
            
            customOverlay:overlay
        },
        {
            src: juice,
            thumbnail: juice,
            originalAlt:'Birthday pouches',
           
            thumbnailHeight: 150,
            
            customOverlay:overlay
        },
        {
            src: juice,
            thumbnail: juice,
            originalAlt:'Birthday pouches',
           
            thumbnailHeight: 150,
            
            customOverlay:overlay
        },
        {
            src: juice,
            thumbnail: juice,
            originalAlt:'Birthday pouches',
           
            thumbnailHeight: 150,
            
            customOverlay:overlay
        },
        {
            src: mori,
            thumbnail: mori,
            originalAlt:'baby',
            thumbnailHeight: 150,
            
            customOverlay:overlay
        },
        {
            src: champ,
            thumbnail: champ,
            originalAlt:'Bottle design',
           
            thumbnailHeight: 150,
            
            customOverlay:overlay
        },
        {
            src: purple,
            thumbnail: purple,
            originalAlt:'Photo Box',
            
            thumbnailHeight: 150,
            
            customOverlay:overlay
        },
        
    ]

    const IMAGES=[
        {original:review,
        thumbnail:review,
        originalAlt:'Shirt and tumbler design',
    },
        {
        original:boat,
        thumbnail:boat,
        originalAlt:'Birthday pouches',
    },
    {
        original:juice,
        thumbnail:juice
    },
    {
        original:mori,
        thumbnail:mori,
        originalAlt:'baby',
    },
    {
        original:birthday,
        thumbnail:birthday,
        originalAlt:'birthday',
    },
    {
        original:graduation,
        thumbnail:graduation,
        originalAlt:'graduation',
    },
    {
        original:champ,
        thumbnail:champ,
        originalAlt:'Bottle design',
    },
    {
        original:purple,
        thumbnail:purple,
        originalAlt:'Photo Box',
    },

]
    images.map((i)=>{
        i.thumbnailWidth=md_down?160:220
    })

    IMAGES.map((i)=>{
        // i.originalWidth = '50'
        i.originalHeight=md_down?'450px':'600px'
      })

  return (
    <Box   display='flex' sx={{justifyContent:"center",}}>
        
        {/* <Gallery maxRows={md_down?1:1} enableImageSelection={false} margin={0} 
        backdropClosesModal={true} 
        rowHeight={md_down?150:260} images={images} customOverlay={overlay} /> */}

<ImageGallery items={IMAGES} showFullscreenButton={false} showThumbnails={false} thumbnailPosition='bottom'
    showBullets={false} autoPlay={true} slideDuration={750} slideInterval={4600}/>
        
    </Box>
    
  )
}

export default CustomerGallery